import React from 'react';

const WrapToggleIcon = React.memo(() => (
  <svg height="100%" width="100%" viewBox="0,0,2048,2048" focusable="false" className="mt-1">
    <path
      type="path"
      style={{ fill: 'transparent' }}
      d="M205 307q0-42 30-72 30-30 72-30h615q42 0 72 30 30 30 30 72v512q0 42-30 73-30 30-72 30h-615q-42 0-72-30-30-30-30-73v-512z m1587 512h-614q-21 0-37-15-15-15-15-36 0-21 15-36 15-15 37-15h614q21 0 36 15 15 15 15 36 0 21-15 36-15 15-36 15z m-1587 359q0-21 15-37 15-15 36-15h1536q21 0 36 15 15 15 15 37 0 21-15 36-15 15-36 15h-1536q-21 0-36-15-15-15-15-36z m0 409q0-21 15-36 15-15 36-15h1536q21 0 36 15 15 15 15 36 0 21-15 36-15 15-36 15h-1536q-21 0-36-15-15-15-15-36z m921-1229q0-21 15-36 15-15 37-15h614q21 0 36 15 15 15 15 36 0 21-15 37-15 15-36 15h-614q-21 0-37-15-15-15-15-37z"
    ></path>
    <path
      type="path"
      style={{ fill: '#357457' }}
      d="M205 307q0-42 30-72 30-30 72-30h615q42 0 72 30 30 30 30 72v512q0 42-30 73-30 30-72 30h-615q-42 0-72-30-30-30-30-73v-512z"
    ></path>
    <path
      type="path"
      style={{ fill: '#3A3A38FF' }}
      d="M1792 819h-614q-21 0-37-15-15-15-15-36 0-21 15-36 15-15 37-15h614q21 0 36 15 15 15 15 36 0 21-15 36-15 15-36 15z m-1587 359q0-21 15-37 15-15 36-15h1536q21 0 36 15 15 15 15 37 0 21-15 36-15 15-36 15h-1536q-21 0-36-15-15-15-15-36z m0 409q0-21 15-36 15-15 36-15h1536q21 0 36 15 15 15 15 36 0 21-15 36-15 15-36 15h-1536q-21 0-36-15-15-15-15-36z m921-1229q0-21 15-36 15-15 37-15h614q21 0 36 15 15 15 15 36 0 21-15 37-15 15-36 15h-614q-21 0-37-15-15-15-15-37z"
    ></path>
  </svg>
));

export default WrapToggleIcon;
